import React, { useState, useEffect } from 'react';
import { ModalContent } from "./styled"
import { Modal } from 'antd';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import EmitidasEditar from '..';

export function ModalExcluirTarefa({ isOpen,
    onClose,
    taskId,
    id,
    recorrencia,
    data,
    clienteId,
    emitidas,
    pendentes,
}) {

    const [isLoadingForm, setIsLoadingForm] = useState(false);
    const [closeModalEditar, setCloseModalEditar] = useState(false);

    useEffect(() => {
        window.parent.postMessage({
          scrollUp: false
        },
          "*");
      },);

    const deleteData = async () => {
        const url = "/portal/rest/contador/obrigacao/remover";
        const param = {
            id: taskId
        }

        setIsLoadingForm(true);
        try {
            const response = await axios.post(url, param, { withCredentials: true });
            toast.success("tarefa excluída com sucesso.");
            emitidas(id, recorrencia, data, clienteId);
            pendentes(id, recorrencia, data, clienteId);
            onClose(true);
            setCloseModalEditar(true);
        } catch {
            toast.error("não foi possível excluir a tarefa");
        } finally {
            setIsLoadingForm(false);
        }
    }

    return (
        <>
            <ModalContent>
                <Modal
                    title={<ExclamationCircleOutlined style={{ fontSize: "larger", color: "darkorange" }} />}
                    open={isOpen}
                    onOk={deleteData}
                    onCancel={onClose}>
                    {isLoadingForm ? (
                        <div >
                            <Box className="loading">
                            <div style={{textAlign:"center"}}>
                                    <CircularProgress />
                                </div>
                            </Box>
                        </div>
                    ) : (
                        <p>Você realmente deseja excluir o registro?</p>
                    )}
                </Modal>
                {false && <EmitidasEditar onClose={closeModalEditar} />}
            </ModalContent>
        </>
    );
};

export default ModalExcluirTarefa;